@if (loaded) {
  <div style="display:flex;align-items:center;justify-content:space-between;padding:20px 24px">
    <h2 style="margin-bottom: 0;">{{ purchaseId ? 'Edit' : 'Add' }} a Purchase</h2>
    <button mat-icon-button type="button" (click)="close()" aria-label="Close"
    style="font-size:2rem;line-height:1;">×</button>
  </div>
  <div mat-dialog-content style="padding-top: 1rem; overflow-x: hidden;">
    <form [formGroup]="form" class="form" style="display:flex;flex-direction:column;gap:16px;">
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Amount *</mat-label>
        <input matInput type="number" formControlName="amount" min="0.01" max="1000000" step="0.01">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Date of Purchase *</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="purchaseDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Purpose *</mat-label>
        <input matInput formControlName="purpose" minlength="5" maxlength="50">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Merchant *</mat-label>
        <input matInput formControlName="merchant" minlength="5" maxlength="50">
      </mat-form-field>
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Category</mat-label>
        <mat-select formControlName="category" placeholder="Choose category">
          @for (category of categories; track category) {
            <mat-option [value]="category">{{ category }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" style="width:100%;">
        <mat-label>Project</mat-label>
        <input matInput formControlName="project">
        @if (showError('project','')) {
          <mat-error>Must have at least three characters</mat-error>
        }
      </mat-form-field>
      <mat-slide-toggle formControlName="billable">Billable</mat-slide-toggle>
      <div
        style="width:100%;background:#e5e5e5;border-radius:8px;padding:16px;display:flex;flex-direction:column;align-items:center;gap:12px;min-height:220px;">
        @if (documentImage) {
          <img [src]="documentImage" alt="Receipt"
            style="max-width:100%;max-height:280px;border-radius:8px;object-fit:contain;">
        } @else {
          <div style="font-size:14px;text-align:center;opacity:.85;">
            Most image types may be uploaded:<br>PNG, GIF, JPG, JPEG
          </div>
          <button mat-raised-button disabled style="text-transform:uppercase;">Add Receipt</button>
        }
      </div>
    </form>
  </div>
  <div mat-dialog-actions style="justify-content:center;">
    <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="saveClicked()"
      style="min-width:280px;text-transform:uppercase;">
      {{ purchaseId ? 'Save' : 'Submit' }} Purchase
    </button>
  </div>
}